export default "__VITE_ASSET__DfvwH6cl__"